// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_f6G","cls2":"ProfilePdfPackCard-cls2_F4k ProfilePdfPackCard-cls1_f6G"};